import { spacing } from '../css-refs.spacing.ts';
import { getLabelStyles } from './form-utils.ts';
import { buildFormFieldWrapperStyles } from '../primitives/hooks/useFormFieldStyles.ts';
import type { CSSProperties } from 'react';

interface FormFieldLabelStyleOptions {
	/** Bottom margin for spacing between label and input */
	marginBottom?: string;
}

/** Shared container styles for form field components; delegates to buildFormFieldWrapperStyles (always full-width, gap spacing.xs). */
export function getFormFieldContainerStyles(): CSSProperties {
	return buildFormFieldWrapperStyles(true, spacing.xs);
}

/** Shared label styles for form field components: base typography from the canonical getLabelStyles in form-utils.ts plus the label/input margin. */
export function getFormFieldLabelStyles(options: FormFieldLabelStyleOptions = {}): CSSProperties {
	const { marginBottom } = options;
	return getLabelStyles({ marginBottom });
}
